import React, { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLinks, ThemeSwitch } from '../../CiscoUi';
import { MainRoutes } from '../../../constants/routes';
import UserPreferencesLink from '../components/UserPreferences/UserPreferencesLink';
import { Header } from '../../Header';
import ConnectedUserPreferencesModal from '../components/UserPreferences/container';
import { ExportHeader } from '../../../pages/Views/Diagram/components/DiagramModals/ExportModal/components/ExportHeader';
import { NavigationButtons } from './components/NavigationButtons';
import { Clone } from './components/Clone';
import { TopologyTitle } from './components/TopologyTitle';
import { ConnectedPush } from './components/Push/container';
import { Schedule } from './components/Schedule';

export type EditHeaderProps = {
  title: string;
  isExporting?: boolean;
  exportingTitle?: string;
};

export function EditHeader({
  title,
  isExporting,
  exportingTitle,
}: EditHeaderProps): ReactElement {
  const { t } = useTranslation();
  const [isSettingsOpen, setSettingsOpen] = useState<boolean>(false);

  const openSettingsModal = (event: { preventDefault: VoidFunction }) => {
    event.preventDefault();
    setSettingsOpen(true);
  };

  if (isExporting) {
    return <ExportHeader exportingTitle={exportingTitle || ''} />;
  }

  return (
    <Header
      autoHideLink={true}
      logoLinkTo={MainRoutes.Main}
      title={t('siteTitle')}
      left={<TopologyTitle title={title} />}
      center={<NavigationButtons />}
      right={
        <>
          <ConnectedPush />
          <Schedule />
          <Clone />
          <NavLinks
            links={[
              {
                label: t('configuration.header.links.home'),
                to: MainRoutes.Main,
              },
              {
                label: t('configuration.header.links.topologies'),
                to: MainRoutes.Topologies,
              },
            ]}
          />
          <UserPreferencesLink onClick={openSettingsModal} />
          <ThemeSwitch />
          {isSettingsOpen && (
            <ConnectedUserPreferencesModal
              onClose={() => setSettingsOpen(false)}
            />
          )}
        </>
      }
    />
  );
}
